module.exports = __webpack_public_path__ + "img/mono_16.8723c8ef.png";